import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "alert-input-sharp" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value", "max"]
const _hoisted_5 = {
  key: 0,
  class: "default-value"
}

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertInputSharp',
  props: {
    severity: {},
    direction: {},
    momChangeRateThreshold: {},
    minQuantityThreshold: {},
    withDefaultDesc: { type: Boolean },
    defaultValueString: { default: undefined }
  },
  emits: ['update:momChangeRateThreshold', 'update:minQuantityThreshold'],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const title = computed(
  () => props.severity + (props.direction === 'excess' ? '_excess_forecast_sharp_decrease' : '_shortage_forecast_sharp_increase')
);
const conditionKey = computed(() =>
  props.direction === 'excess'
    ? 'dashboard:アラート条件:前回受領内示比n%以下かつ差分数量m以上'
    : 'dashboard:アラート条件:前回受領内示比n%以上かつ差分数量m以上'
);

return (_ctx: any,_cache: any) => {
  const _component_I18nT = _resolveComponent("I18nT")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(title.value)), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_I18nT, {
        keypath: conditionKey.value,
        tag: "div",
        class: "alert-input-sharp__condition"
      }, {
        n: _withCtx(() => [
          _createElementVNode("input", {
            key: "mom-change-rate-threshold",
            value: props.momChangeRateThreshold,
            type: "number",
            min: "0",
            max: "999",
            class: "alert-input-sharp__input alert-input-sharp__input--percentage",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:momChangeRateThreshold', $event))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["e"]))
          }, null, 40, _hoisted_3)
        ]),
        m: _withCtx(() => [
          _createElementVNode("input", {
            key: "min-quantity-threshold",
            value: props.minQuantityThreshold,
            type: "number",
            min: "0",
            max: Number.MAX_SAFE_INTEGER,
            class: "alert-input-sharp__input alert-input-sharp__input--quantity",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (emits('update:minQuantityThreshold', $event))),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["e"]))
          }, null, 40, _hoisted_4)
        ]),
        _: 1
      }, 8, ["keypath"])
    ]),
    (_ctx.defaultValueString)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.defaultValueString), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})